module.exports = __webpack_public_path__ + "static/media/EFarming.5963e2c7.pptx";